var szBankStorage = {
	$setYfBankStorage:function(key,value){
		localStorage.setItem(key,JSON.stringify(value))
	},
	$getYfBankStorage:function(key){
	 return	JSON.parse(localStorage.getItem(key))
	},
	$setZcBankStorage:function(key,value){
		localStorage.setItem(key,JSON.stringify(value))
	},
	$getZcBankStorage:function(key){
	 return	JSON.parse(localStorage.getItem(key))
	},
	$setSzBankStorage:function(key,value){
		localStorage.setItem(key,JSON.stringify(value))
	},
	$getSzBankStorage:function(key){
	 return	JSON.parse(localStorage.getItem(key))
	},
	$getNowYear:function(){
		var date =new Date()
		return date.getFullYear()
	},
	$getYearList:function(){
		var date =new Date()
		let nowYear= date.getFullYear()
		let list=[{
			lable:nowYear,
			value:nowYear
		}]
		for (let i = 0; i < 20; i++) {
			list.push({
			lable:nowYear+1,
			value:nowYear+1
		})
		nowYear++
		}
		let nowYearback= date.getFullYear()
		for (let i = 0; i < 20; i++) {
			list.unshift({
			lable:nowYearback-1,
			value:nowYearback-1
		})
		nowYearback--
		}
		return list
	},
	$title2_select:[
		{
			value:'房屋、建筑物',
			lebal:'房屋、建筑物'
		},
		{
			value:'飞机、火车、轮船、机器、机械、其他生产设备',
			lebal:'飞机、火车、轮船、机器、机械、其他生产设备'
		},
		{
			value:'与生产经营活动有关的器具、工具、家具等',
			lebal:'与生产经营活动有关的器具、工具、家具等'
		},
		{
			value:'飞机、火车、轮船以外的运输工具',
			lebal:'飞机、火车、轮船以外的运输工具'
		},
		{
			value:'电子设备',
			lebal:'电子设备'
		},
		{
			value:'其他',
			lebal:'其他'
		},
	],
	$title1_select:[
		{
			value:'重要行业固定资产加速折旧(不含一次性扣除）',
			lebal:'重要行业固定资产加速折旧(不含一次性扣除）'	
		},
		{
			value:'其他行业研发设备加速折旧',
			lebal:'其他行业研发设备加速折旧'	
		},
		{
			value:'海南自由贸易港企业固定资产加速折旧',
			lebal:'海南自由贸易港企业固定资产加速折旧'	
		},
		{
			value:'500万元以下设备器具一次性扣除',
			lebal:'500万元以下设备器具一次性扣除'	
		},
		{
			value:'疫情防控重点保障物资生产企业单价500万元以上设落一次性扣除',
			lebal:'疫情防控重点保障物资生产企业单价500万元以上设落一次性扣除'	
		},
		{
			value:'海南自由贸易港企业固定资产一次性扣除',
			lebal:'海南自由贸易港企业固定资产一次性扣除'	
		},
		{
			value:'技术进步、更新换代固定资产加速折旧',
			lebal:'技术进步、更新换代固定资产加速折旧'	
		},
		{
			value:'常年强震动、高腐蚀固定资产加速折旧',
			lebal:'常年强震动、高腐蚀固定资产加速折旧'	
		},
		{
			value:'外购软件加速折旧',
			lebal:'外购软件加速折旧'	
		},
		{
			value:'集成电路企业生产设备加速折旧',
			lebal:'集成电路企业生产设备加速折旧'	
		},
	],
	$title3_select:[
		{
			value:'林木类',
			lebal:'林木类'	
		},
		{
			value:'畜类',
			lebal:'畜类'	
		},
	],
	$title4_select:[
		{
			value:'专利权',
			lebal:'专利权'	
		},
		{
			value:'商标权',
			lebal:'商标权'	
		},
		{
			value:'著作权',
			lebal:'著作权'	
		},
		{
			value:'土地使用权',
			lebal:'土地使用权'	
		},
		{
			value:'非专利技术',
			lebal:'非专利技术'	
		},	
		{
			value:'特许权使用费',
			lebal:'特许权使用费'	
		},	
		{
			value:'软件',
			lebal:'软件'	
		},	
		{
			value:'其他',
			lebal:'其他'	
		},	
	],
	$title5_select:[
		{
			value:'企业外购软件加速摊销',
			lebal:'企业外购软件加速摊销'	
		},
		{
			value:'海南自由贸易港企业无形资产加速摊销',
			lebal:'海南自由贸易港企业无形资产加速摊销'	
		},
		{
			value:'海南自由贸易港企业无形资产一次性摊销',
			lebal:'海南自由贸易港企业无形资产一次性摊销'	
		}
	],
	$title6_select:[
		{
			value:'已足额提取折旧的固定资产的改建支出',
			lebal:'已足额提取折旧的固定资产的改建支出'	
		},
		{
			value:'租入固定资产的改建支出',
			lebal:'租入固定资产的改建支出'	
		},
		{
			value:'固定资产的大修理支出',
			lebal:'固定资产的大修理支出'	
		},
		{
			value:'开办费',
			lebal:'开办费'	
		},
		{
			value:'其他',
			lebal:'其他'	
		}
	],
	$title7_select:[
		{
			value:'油气勘探投资',
			lebal:'油气勘探投资'	
		}
	],
	$title8_select:[
		{
			value:'油气开发投资',
			lebal:'油气开发投资'	
		}
	],
	$cyclelist:[
		{
			label:"按年",
			value:"1"
		},
		{
			label:"按季",
			value:"2"
		},
		{
			label:"按月",
			value:"3"
		},
	],
	$proplist:[
		{
			label:"管理费用",
			value:1
		},
		{
			label:"销售费用",
			value:2
		},
	],
	$getdemoCompany:[
			{
				label:"北京和利时控制技术有限公司",
				value:2
			},
			{
				label:"山东鲁抗医药工程设计有限公司",
				value:3
			},
	],
	$projectlist:[
		{
			label:"国债地方债免税",
			value:1
		},
		{
			label:"证券投资基金分红",
			value:2
		},
		{
			label:"长期股权投资",
			value:3
		},
		{
			label:"业务招待费",
			value:4
		},
		{
			label:"职工福利费",
			value:5
		},
		{
			label:"工会经费",
			value:6
		},
		{
			label:"职工教育经费",
			value:7
		},
		{
			label:"补充医疗保险",
			value:8
		},
		{
			label:"补充养老保险",
			value:9
		}
	],
	toThousands:function(num){
		function toFixed(number, m) {
		    if (typeof number !== 'number') {
		        throw new Error("number不是数字");
		    }
		    let result = Math.round(Math.pow(10, m) * number) / Math.pow(10, m);
		    result = String(result);
		    if (result.indexOf(".") == -1) {
		        if(m != 0){
		            result += ".";
		            result += new Array(m + 1).join('0');
		        }
		    } else {
		        let arr = result.split('.');
		        if (arr[1].length < m) {
		            arr[1] += new Array(m - arr[1].length + 1).join('0')
		        }
		        result = arr.join('.')
		    }
		    return result
		}
		if (num == null || num == "undefined" || num == undefined || isNaN(num)) {
			return "0";
		} else if (num == "") {
			return toFixed(parseFloat(0),2)
		} else {
			if (num < 0) {
				var numstr = String(num);
				var nums = numstr.substr(1);
				var s = toFixed(parseFloat(nums),2);
				var L = s.split(".")[0].split("").reverse();
				var r = s.split(".")[1];
				var t = "";
				for (var i = 0; i < L.length; i++) {
					if ((i + 1) % 3 == 0 && (i + 1) != L.length) {
						t += L[i] + ",";
					} else {
						t += L[i] + "";
					}
				}
				return "-" + t.split("").reverse().join("") + "." + r;
			} else if (num > 0) {
				var s = toFixed(parseFloat(num),2);
				var L = s.split(".")[0].split("").reverse();
				var r = s.split(".")[1];
				var t = "";
				for (var i = 0; i < L.length; i++) {
					if ((i + 1) % 3 == 0 && (i + 1) != L.length) {
						t += L[i] + ",";
					} else {
						t += L[i] + "";
					}
				}
				return t.split("").reverse().join("") + "." + r;
			} else {
				return toFixed(parseFloat(0),2);
			}
		}
	}
}	
export {
	szBankStorage
}
